import React, { Component, useCallback } from 'react';
import PageTitle from "../../Components/PageTitle";
import { SubmitBtn } from "../../Components/InputElements";
import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { ContentLoader, NoRecords } from "../../Components/Shimmer";

class Modilds extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            company_module_id: 0,
            company_id: 0,
            module: 0,
            module_status: '1',
            rows: [],
            companies: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            errors: {},
        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetCompaniesList();
        })
    }

    handleInputChange = (e) => {
        const errors = { ...this.state.errors };
        delete errors[e.target.name];

        this.setState({
            [e.target.name]: e.target.value,
            errors: errors,
        });
    };

    handleSelectChange = (name, selectedOption) => {

        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    handleRadioChange = (name, value) => {

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    GetInfo = () => {
        const { apiURL, apiHeaderJson } = this.context;
        const headers = apiHeaderJson;
        axios.get(`${apiURL}CompanyMasters/GetCompanyModildInfo`, {
            params: {
                company_module_id: this.state.company_module_id,
            }, headers
        }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.resetForm();
                this.setState(
                    {
                        company_module_id: data[0].company_module_id,
                        module: data[0].module,
                        company_id: data[0].company_id,
                        module_status: data[0].module_status,
                    }
                )
            }
        });
    }
    GetList = () => {
        const { apiURL, apiHeaderJson } = this.context;
        const headers = apiHeaderJson;
        axios.get(`${apiURL}CompanyMasters/GetCompanyModilds`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {

            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }
    // 'GetCompaniesList' replaced with 'getCompanies' 
    GetCompaniesList = () => {
        const { apiURL, apiHeaderJson } = this.context;
        const headers = apiHeaderJson;
        axios.get(`${apiURL}CompanyMasters/getCompanies`, { headers })
        .then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState((prevState) => ({
                    companies: data.companies.map((row) => ({
                        value: row.company_id,
                        label: row.company_name
                    }))
                }));
            }
        });
    }

    validateForm = () => {
        const errors = {};
        
        // Check if company_id is selected
        if (this.state.company_id === 0) {
            errors.company_id = 'Company is required';
        }

        // Check if module is selected
        if (this.state.module === 0) {
            errors.module = 'Module is required';
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (!this.validateForm()) {
            return;
        }
        const { apiURL, apiHeaderJson } = this.context;
        const headers = apiHeaderJson;
        var formData = {
            module: this.state.module,
            module_status: this.state.module_status,
            company_id: this.state.company_id,
        }
        if (this.state.company_module_id !== 0) {
            formData.company_module_id = this.state.company_module_id;
        }

        axios.post(`${apiURL}CompanyMasters/CreateCompanyModilds`, formData, { headers }).then((response) => {
            const { success } = response.data;
            if (success === true) {
                this.resetForm();
                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                })
            } else {
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                })
                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
            }

        })
    };
    resetForm = () => {
        this.setState({
            errors: {},
            company_module_id: 0,
            module_status: '1',
            module: 0,
            company_id: 0,
        })

    }

    handleDelete = (id) => {
        const { apiURL, apiHeaderJson } = this.context;
        const headers = apiHeaderJson;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    company_module_id: id
                };
                axios
                    .post(`${apiURL}CompanyMasters/DeleteCompanyModilds`, formData, { headers })
                    .then((response) => {

                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            timerProgressBar: true,
                            showConfirmButton: false,
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {

        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    render() {
        const options = [
            { value: 'leaves', label: 'Leaves' },
            { value: 'leaves_pluse', label: 'Leaves SandBox' },
            { value: 'attendance', label: 'Attendance' },
            { value: 'salary_details', label: 'Salary details' },
            { value: 'documents', label: 'Documents' },
            { value: 'payslip', label: 'payslip' },
            { value: 'pms', label: 'PMS' },
            { value: 'expense', label: 'Expense' },
            { value: 'resignation', label: 'Resignation' },
            { value: 'policy', label: 'Policy' }, 
            { value: 'holiday', label: 'Holiday' }, 
        ];
        const { errors, loadingList } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    {loadingList === false ? (
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Module Management`} primary={`Home`} />
                            <div className="row">
                                <div className="col-md-5">
                                    <div className="card">
                                        <div className="card-header align-items-center d-flex">
                                            <h4 className="card-title mb-0 flex-grow-1">Module Management</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="row gy-4">
                                                <div className="col-md-12">
                                                    <form onSubmit={this.handleSubmit} className="row">
                                                        <div className="col-md-12">
                                                            <label for="company_name">Select company</label>
                                                            <Select
                                                                options={this.state.companies}
                                                                value={this.state.companies ? this.state.companies.find(option => option.value === this.state.company_id) : null}
                                                                onChange={(selectedOption) => this.handleSelectChange('company_id', selectedOption)}
                                                                name='company_id'
                                                                placeholder={`Select company`}
                                                                />
                                                            {errors.company_id && <div className="text-danger">{errors.company_id}</div>}
                                                        </div>

                                                        <div className="col-md-12" style={{ marginTop: "10px" }}>
                                                            <label for="module">Select module</label>
                                                            <Select
                                                                options={options}
                                                                value={options ? options.find(option => option.value === this.state.module) : null}
                                                                onChange={(selectedOption) => this.handleSelectChange('module', selectedOption)}
                                                                name='module'
                                                                placeholder={`Select module`}
                                                            />
                                                            {errors.module && <div className="text-danger">{errors.module}</div>}
                                                        </div>
                                                        <div className="col-md-6 mt-3">
                                                            <div>
                                                                <label htmlFor="module_status0" className="form-label">Hide module:</label>
                                                            </div>
                                                            <div className="form-check form-check-inline mt-2" >
                                                                <input
                                                                    type="radio"
                                                                    id="module_status0"
                                                                    name="module_status"
                                                                    value="0"
                                                                    checked={this.state.module_status == '0'}
                                                                    onChange={() => this.handleRadioChange('module_status', '0')}
                                                                    className={`form-check-input`}
                                                                />
                                                                <label htmlFor="module_status0" className="form-check-label">Yes</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="module_status1"
                                                                    name="module_status"
                                                                    value="0"
                                                                    checked={this.state.module_status == '1'}
                                                                    onChange={() => this.handleRadioChange('module_status', '1')}
                                                                    className={`form-check-input`}
                                                                />
                                                                <label htmlFor="module_status1" className="form-check-label">No</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                            <SubmitBtn text={this.state.company_module_id !== 0 ? 'Update' : 'Save'} type="primary" icon="ri-save-line" />
                                                            {this.state.company_module_id !== 0 &&
                                                                <button
                                                                    style={{ float: 'right' }}
                                                                    type="button"
                                                                    className="btn btn-light right btn-label"
                                                                    onClick={() => this.resetForm()}
                                                                >
                                                                    <i className=" ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> New
                                                                </button>
                                                            }
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    <div className='card'>
                                        <div className="col-md-12">
                                            <table className={`table table-bordered table-stripped`}>
                                                <thead className='table-light'>
                                                    <tr>
                                                        <th>Company name</th>
                                                        <th>Modules</th>
                                                        <th>Hide modules status</th>
                                                        <th className='text-center' width={120}>Action</th>
                                                    </tr>
                                                </thead>
                                                {this.state.rows.length !== 0 ? (
                                                    <tbody>
                                                        {this.state.rows.map((row) => (
                                                            <tr key={row.company_module_id}>
                                                                <td>{row?.legal_entity_name || row?.company_name}</td>
                                                                <td>{row.module}</td>
                                                                <td>{row.module_status_label}</td>
                                                                <td className='d-flex justify-content-around'>
                                                                    <button
                                                                        type='button'
                                                                        onClick={() => this.setState({ company_module_id: row.company_module_id }, () => this.GetInfo())}
                                                                        className="btn-icon btn btn-sm btn-outline-primary"
                                                                    >
                                                                        <i className="ri-edit-box-line"></i>
                                                                    </button>
                                                                    <button
                                                                        onClick={() => this.handleDelete(row.company_module_id)}
                                                                        className="btn-icon btn btn-sm btn-outline-danger"
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan="4">
                                                                <NoRecords />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}
                                                <tfoot className='table-light'>
                                                    <tr>
                                                        <th colSpan={6} >
                                                            <div className="d-flex justify-content-between" >
                                                                <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                                <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    {
                                                                        <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                    }
                                                                </div>
                                                                <div className='col-md-2'>
                                                                    <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                        {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                            <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                            </div>
                                                        </th>
                                                    </tr>

                                                </tfoot>

                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>) :
                        <ContentLoader />
                    }
                </div>
            </div>
        )
    };
}
export default withRouter(Modilds);